import IconItem from 'v3/components/IconItem';
import * as S from './styles';

type optionItem = {
  icon: React.ReactNode;
  text: React.ReactNode;
};

export type HeroTypes = {
  title: React.ReactNode;
  optionsList?: optionItem[];
  img: string;
  alt?: string;
};

const Hero = ({ title, optionsList = [], img, alt = '' }: HeroTypes) => (
  <S.Wrapper>
    <S.Container>
      <S.Content>
        <S.Title>{title}</S.Title>

        {!!optionsList && (
          <S.CustomContent>
            {optionsList.map((item, index) => (
              <IconItem
                key={`item-${index}`}
                icon={item.icon}
                text={item.text}
              />
            ))}
          </S.CustomContent>
        )}
      </S.Content>

      <S.Image src={img} alt={alt} />
    </S.Container>
  </S.Wrapper>
);

export default Hero;
